import * as XLSX from 'xlsx';
import { Half, halfYearMonths, toMonth } from './period';
import { sheetToAoaFullRange } from './readXlsx';
import { ChannelResult, CoupangMonthRow } from './types';

function norm(s: any): string { return String(s ?? '').replace(/\s+/g, ''); }
function num(v: any): number { return Number(v) || 0; }

export function parseCoupangRows(aoa: any[][], year: number, half: Half): ChannelResult<CoupangMonthRow> {
  const header = (aoa[0] || []).map(norm);
  const idx = (name: string) => header.indexOf(norm(name));
  const cDate = idx('매출인식일');
  const cCardSale = idx('신용카드(판매)');
  const cCashSale = idx('현금(판매)');
  const cEtcSale = idx('기타(판매)');
  const cCardRefund = idx('신용카드(환불)');
  const cCashRefund = idx('현금(환불)');
  const cEtcRefund = idx('기타(환불)');

  const target = halfYearMonths(year, half);
  const byMonth = new Map<string, CoupangMonthRow>();

  for (let i = 1; i < aoa.length; i++) {
    const row = aoa[i];
    if (!row) continue;
    const month = toMonth(row[cDate]);
    if (!target.includes(month)) continue;
    const card = num(row[cCardSale]) - num(row[cCardRefund]);
    const cash = num(row[cCashSale]) - num(row[cCashRefund]);
    const etc = num(row[cEtcSale]) - num(row[cEtcRefund]);
    if (card === 0 && cash === 0 && etc === 0) continue;

    if (!byMonth.has(month)) byMonth.set(month, { month, total: 0, card: 0, cash: 0, etc: 0 });
    const mr = byMonth.get(month)!;
    mr.card += card; mr.cash += cash; mr.etc += etc;
    mr.total += card + cash + etc;
  }

  const rows = Array.from(byMonth.values()).sort((a, b) => a.month.localeCompare(b.month));
  const rollup = rows.map(r => ({ month: r.month, taxable: 0, exempt: r.total }));
  return { channel: '쿠팡', rows, rollup };
}

export function parseCoupangFile(file: File, year: number, half: Half): Promise<ChannelResult<CoupangMonthRow>> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const wb = XLSX.read(data, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const aoa = sheetToAoaFullRange(ws);
        resolve(parseCoupangRows(aoa, year, half));
      } catch (err) { reject(err); }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });
}
